"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcNameStamp = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var AcNameStamp_module_scss_1 = __importDefault(require("./AcNameStamp.module.scss"));
var AcNameStamp = function (_a) {
    var nameCharacter = _a.nameCharacter, inCharge = _a.inCharge, _b = _a.size, size = _b === void 0 ? 30 : _b, className = _a.className;
    var isNone = inCharge === 'NONE';
    var isMine = inCharge === 'MINE';
    var isNotMine = inCharge === 'NOT_MINE';
    var showTooltip = true;
    var content = (react_1.default.createElement("div", { style: { width: size, height: size }, className: clsx_1.default('nameStamp', className, {
            'incharge-none': isNone,
            'incharge-mine': isMine,
            'incharge-not-mine': isNotMine,
        }, { 'cursor-default': !showTooltip }), tabIndex: -1 },
        react_1.default.createElement("span", { className: "fs-16 m-auto " + AcNameStamp_module_scss_1.default.nameStampText }, nameCharacter)));
    return react_1.default.createElement(react_1.default.Fragment, null, content);
};
exports.AcNameStamp = AcNameStamp;
exports.AcNameStamp.displayName = 'AcNameStamp';
//# sourceMappingURL=AcNameStamp.js.map